import { ref, reactive } from 'vue';

export let str = ref();
export let list = ref(['', '']);
export let obj = ref({ a: '', b: '' });
export let formState = reactive({ c: '', d: '' });
export let arr = reactive(['', '']);
export default { e: 'e', f: 'f' };
